// Phase 5Z.9 — Fahrer-Portal API client + auth helpers
import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = "fahrer_token";

export const FAHRER_API_BASE = `${BASE}/api`;

export const fahrerApi = axios.create({
  baseURL: `${BASE}/api`,
  withCredentials: true,
});

fahrerApi.interceptors.request.use((config) => {
  const tok = localStorage.getItem(TOKEN_KEY);
  if (tok) config.headers.Authorization = `Bearer ${tok}`;
  return config;
});

fahrerApi.interceptors.response.use(
  (r) => r,
  (e) => {
    if (e?.response?.status === 401 && window.location.pathname.startsWith("/fahrer") && window.location.pathname !== "/fahrer/login") {
      localStorage.removeItem(TOKEN_KEY);
      window.location.href = "/fahrer/login";
    }
    return Promise.reject(e);
  }
);

export const fahrerToken = {
  get: () => localStorage.getItem(TOKEN_KEY),
  set: (t) => localStorage.setItem(TOKEN_KEY, t),
  clear: () => localStorage.removeItem(TOKEN_KEY),
};

export async function fahrerLogin(username, password) {
  const { data } = await fahrerApi.post("/fahrer/auth/login", { username, password });
  fahrerToken.set(data.access_token);
  return data;
}

export async function fahrerLogout() {
  try { await fahrerApi.post("/fahrer/auth/logout"); } catch { /* ignore */ }
  fahrerToken.clear();
}

export async function fahrerMe() {
  const { data } = await fahrerApi.get("/fahrer/auth/me");
  return data;
}

export async function fahrerChangePassword(current_password, new_password) {
  const { data } = await fahrerApi.post("/fahrer/auth/change-password", {
    current_password, new_password,
  });
  return data;
}

export async function fahrerSetLanguage(language) {
  await fahrerApi.post("/fahrer/auth/language", { language });
}
